import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface InfoIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

const InfoIcon: React.FC<InfoIconProps> = ({
  size = 16,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();
  return (
    <Svg {...props} width={size} height={size} viewBox="0 0 11 14" fill="none">
      <Path
        d="M4.83931 1.12331C4.83931 1.74306 5.31397 2.23886 5.90729 2.23886C6.50803 2.23886 6.96786 1.74306 6.96786 1.12331C6.96786 0.495804 6.50803 0 5.90729 0C5.31397 0 4.83931 0.495804 4.83931 1.12331ZM3 11.3648C3 11.7444 3.25958 12 3.65266 12H8.34734C8.74042 12 9 11.7444 9 11.3648C9 10.9929 8.74042 10.7373 8.34734 10.7373H6.85661V4.82634C6.85661 4.40801 6.59703 4.12912 6.21137 4.12912H3.86032C3.47466 4.12912 3.20766 4.37702 3.20766 4.74887C3.20766 5.13622 3.47466 5.39187 3.86032 5.39187H5.48455V10.7373H3.65266C3.25958 10.7373 3 10.9929 3 11.3648Z"
        fill={colors[color]}
      />
    </Svg>
  );
};

InfoIcon.displayName = 'InfoIcon';
export { InfoIcon };
